export function getInterestOrNot(pricingType: string) {
  let rlt = false
  try {
    if (pricingType.includes('I/O') || pricingType.includes('IO')) rlt = true
  } catch {}
  return rlt
}
